import Contingency from "../Contingency";

describe("Contingency model", () => {
  test("belongsTo relations", () => {
    expect(
      Contingency.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
